var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimFormActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.74 19C22.74 19.17 22.72 19.33 22.7 19.49L23.77 20.32C23.8149 20.3585 23.8454 20.4113 23.8563 20.4694C23.8672 20.5276 23.8579 20.5878 23.83 20.64L22.83 22.37C22.76 22.48 22.63 22.52 22.52 22.48L21.27 21.98C21.02 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 19.99 24H17.99C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 21.98L15.46 22.48C15.34 22.52 15.21 22.48 15.15 22.37L14.15 20.64C14.1221 20.5878 14.1128 20.5276 14.1237 20.4694C14.1346 20.4113 14.1651 20.3585 14.21 20.32L15.27 19.49C15.2289 19.1646 15.2289 18.8354 15.27 18.51L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.52 15.35 15.48 15.46 15.52L16.7 16.02C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 17.99 14H19.99C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21.01 15.82 21.27 16.02L22.51 15.52C22.63 15.48 22.76 15.52 22.82 15.63L23.82 17.36C23.8479 17.4122 23.8572 17.4724 23.8463 17.5306C23.8354 17.5887 23.8049 17.6415 23.76 17.68L22.7 18.51C22.73 18.67 22.74 18.83 22.74 19ZM17.49 19C17.49 19.83 18.16 20.5 18.99 20.5C19.82 20.5 20.49 19.83 20.49 19C20.49 18.17 19.82 17.5 18.99 17.5C18.16 17.5 17.49 18.17 17.49 19Z",
    fill: "#9E3039"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 11.5C19.33 11.5 19.66 11.53 19.99 11.57L20 0L0 20H11.56C11.52 19.67 11.49 19.34 11.49 19C11.49 14.86 14.85 11.5 18.99 11.5Z",
    fill: "#9E3039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimFormActive);
export default __webpack_public_path__ + "static/media/claim_form_active.b47474b53b4ce8a6032be656da186249.svg";
export { ForwardRef as ReactComponent };